module.exports = __webpack_public_path__ + "static/media/fortnite-selector-color.b96bbc31.png";